var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7V43H50V7H0ZM2 9H48V11.5C47.6094 11.8398 30.0742 27.1367 28.4375 28.5625L28.3438 28.6562C27.0469 29.7852 25.7188 30 25 30C24.2852 30 22.9531 29.7852 21.6562 28.6562C21.2852 28.332 18.6133 26.0234 16.6875 24.3438C10.9727 19.3594 2.29297 11.7578 2 11.5V9ZM2 14.1562C3.73438 15.668 9.88672 21.0234 15.125 25.5938L2 35.9688V14.1562ZM48 14.1562V35.9688L34.875 25.5938C40.1133 21.0234 46.2656 15.668 48 14.1562ZM16.6562 26.9375C17.8711 27.9961 20.0664 29.9141 20.3438 30.1562L20.375 30.1875C22.0664 31.6406 23.8633 32 25 32C26.1445 32 27.957 31.6367 29.6562 30.1562C29.9375 29.9141 32.1484 28.0078 33.375 26.9375L48 38.5V41H2V38.5L16.6562 26.9375Z",
    fill: "#FFC542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.688dbe7c31d5e02b580db6a40169eb42.svg";
export { ForwardRef as ReactComponent };